export type SpringHelperConfig = {
  stiffness?: number;
  damping?: number;
  precision?: number;
};

export const shaky: SpringHelperConfig = {
  stiffness: 1296,
  damping: 9,
};

export const smooth: SpringHelperConfig = {
  stiffness: 196,
  damping: 28,
};

export const snappy: SpringHelperConfig = {
  stiffness: 1296,
  damping: 72,
};

export const wobbly: SpringHelperConfig = {
  stiffness: 196,
  damping: 3,
};
